<template>
    <div class="selected" ref="selectBox" @click.stop="showOptions" :class="{on: showOption}" :ga-data="gaData">
        <span v-if="judgeVal()">{{getOptionVal(selected)}}</span>
        <span v-else class="holder">{{holderText}}</span>
        <img src="../../images/arrow_down_circle.svg" class="sel-arr" :class="{on: showOption}" />
        <k-option @closePopover="closeOptions" ref="option" v-if="showOption" :selected="selected" :size="size" :pos="pos" :val="options"></k-option>
    </div>
</template>

<script>
    import kOption from './option.vue';

    /**
     * 
     * getCoords
     * 获取dom元素距离文档root的left 和top值
     */
    function getCoords(elem) {
        var box = elem.getBoundingClientRect();

        var body = document.body;
        var docEl = document.documentElement;

        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        var clientTop = docEl.clientTop || body.clientTop || 0;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;

        var top  = box.top +  scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;

        return { top: Math.round(top), left: Math.round(left) };
    }

    export default {
        name: 'k-select',
        components: {
            kOption
        },
        props: [
            'selected',
            'options',
            'holderText',
            'gaData'
        ],
        data (){
            return {
                showOption: false,
                pos: {},
                size: {},
                available: true
            };
        },
        methods: {
            getPos (){
                this.pos = getCoords(this.$refs['selectBox']);
            },
            getSize (){
                this.size = {
                    width: this.$refs['selectBox'].offsetWidth,
                    height: this.$refs['selectBox'].offsetHeight
                };
            },
            showOptions (){
                if (!this.available) return;
                this.getPos();
                this.getSize();
                this.showOption = true;
            },
            closeOptions (item){
                this.showOption = false;
                if(item){
                    this.selectedItem = item;
                    this.$emit('selectedOption', item);
                }
                this.available = false;
                setTimeout(()=>{
                    this.available = true;
                },500);
            },
            getOptionVal(id){

                let val = "";
                this.options.forEach((i)=>{
                    if (i.id==id) {
                        val = i.val;
                    }
                });
                return val;
            },
            judgeVal(){
                for (let i = 0; i < this.options.length; i++) {
                    const ele = this.options[i];
                    if (ele.id == this.selected){
                        return true;
                    }
                }
                return false;
            },
            attachClick() {
                var vm = this;
                document.body.addEventListener("click", vm.handleClose);
            },
            removeClick() {
                var vm = this;
                document.body.removeEventListener("click", vm.handleClose);
            },
            handleClose(e) {
                if (e.target != this.$refs['option'] && e.target != this.$refs['selectBox'] && e.target.parentElement != this.$refs['selectBox']) {
                    this.showOption = false
                }
            }
        },
        created (){
            this.selectedItem = this.selected;
        },
        mounted() {
            this.attachClick();
        },
        beforeDestory() {
            this.removeClick();
        }
    };
</script>

<style lang="scss" scoped>
    .selected {
        padding: 0 .4rem 0 .12rem;
        box-sizing: border-box;
        color: #50BBE5;
        cursor: pointer;
        position: relative;
        height: .4rem;
		line-height: .4rem;
		border-radius: .2rem;
        border: 1px solid #ccc;
        font-size: 0;
        &.on{
            border: 1px solid #50BBE5;
        }
        span{
            font-size: .12rem;
            color: #444;
            display: inline-block;
            &.holder{
                color: #cccccc;
            }
        }
        &.err{
            border: 1px solid #FF5555;
        }
    }
    .sel-arr {
        position: absolute;
        top: .12rem;
        right: .14rem;
        width: .12rem;
        display: inline-block;
        transition: transform 0.2s;
        &.on {
            transform: rotate(180deg);
        }
    }

</style>
